export default {
  redeemGift: {
    en: 'Redeem Gift',
  },
  redeemCoupon: {
    en: 'Redeem Coupon',
  },
}
